import { useTranslation } from 'react-i18next';
import { Loader2 } from 'lucide-react';
import { useAppSelector } from '@/app/hooks';
import {
  selectCanvasUiPayload,
  selectIsCanvasLoading,
} from '@/features/canvas/canvasSlice';
import { DynamicComponent } from '../dynamic/DynamicComponent';
import DefaultCanvas from '../dynamic/DefaultCanvas';

export const CanvasPanel = () => {
  const { t } = useTranslation();
  const uiPayload = useAppSelector(selectCanvasUiPayload);
  const isLoading = useAppSelector(selectIsCanvasLoading);

  const renderContent = () => {
    if (isLoading) {
      return (
        <div className="flex flex-col items-center text-muted-foreground">
          <Loader2 className="h-12 w-12 animate-spin" />
          <p className="mt-2 text-sm">{t('canvas.loading', 'Loading...')}</p>
        </div>
      );
    }

    if (uiPayload) {
      return <DynamicComponent uiPayload={uiPayload} />;
    }

    return <DefaultCanvas />;
  };

  return (
    <div className="flex flex-col h-full bg-muted/40">
      <div className="flex-grow flex items-center justify-center relative p-4">
        {renderContent()}
      </div>
    </div>
  );
};
